import Vue from 'vue';
import AccountBalanceQuery from './account-balance-query/account-balance-query.vue';
Vue.component('account-balance-query', AccountBalanceQuery);
